<script>
    import printJS from 'print-js'

    export default {
        methods: {
            print(route) {
                document.body.style.cursor = 'wait'

                axios.get(route, {
                    responseType: 'arraybuffer'
                })
                .then(function(response) {
                    document.body.style.cursor = 'default'
                    let fileURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))

                    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        window.open(fileURL,"_blank");
                    } else {
                        printJS(fileURL)
                    }
                })
            },
        },
    }
</script>
